import { render, staticRenderFns } from "./FinishedChat.vue?vue&type=template&id=413dc58f"
import script from "./FinishedChat.vue?vue&type=script&lang=js"
export * from "./FinishedChat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports